import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  profits: [],
  profitDetail: null
};
const getters = {
  profits: state => state.profits,
  profitDetail: state => state.profitDetail,
};
const mutations = {
  [TYPES.SET_PROFITS](state, payload) {
    state.profits = payload;
  },
  [TYPES.SET_PROFIT_DETAIL](state, payload) {
    state.profitDetail = payload;
  }
};
const actions = {
  /**
   * 获取利润表
   * @param commit
   */
  getProfits: ({commit}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/profits",{params:{sort:'companyId,desc'}})
      .then(response => {
        commit(TYPES.SET_PROFITS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取利润表详情
   * @param commit
   * @param balanceSheetId
   */
  getProfitDetail: ({commit}, profitId) => {
    commit(TYPES.SET_PROFIT_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/profits/" + profitId)
      .then(response => {
        commit(TYPES.SET_PROFIT_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}